//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is
the property of 6over6 Ltd. and its licensors. Any use of the Software is
strictly prohibited unless an explicit license or permission is granted by
6over6 Ltd.s
<template>
  <svg
    width="80"
    height="70"
    viewBox="0 0 80 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      x1="15"
      y1="29.5"
      x2="67"
      y2="29.5"
      stroke="#15192E"
      stroke-width="5"
    />
    <rect
      x="15.1366"
      y="50.9456"
      width="32.8091"
      height="51.4216"
      rx="4.6122"
      transform="rotate(-89.8756 15.1366 50.9456)"
      :style="{ stroke: store.state.Style.themeColor }"
      stroke-width="2.26829"
    />
  </svg>
</template>

<script setup>
import { useStore } from "vuex";
const store = useStore();
</script>
